export default "__VITE_ASSET__19e9a089__"